/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DelegationSummary,
    DelegationSummaryFromJSON,
    DelegationSummaryFromJSONTyped,
    DelegationSummaryToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface DelegationSummaryResponse
 */
export interface DelegationSummaryResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof DelegationSummaryResponse
     */
    msg: string;
    /**
     * 
     * @type {DelegationSummary}
     * @memberof DelegationSummaryResponse
     */
    entry: DelegationSummary;
}

export function DelegationSummaryResponseFromJSON(json: any): DelegationSummaryResponse {
    return DelegationSummaryResponseFromJSONTyped(json, false);
}

export function DelegationSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegationSummaryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': DelegationSummaryFromJSON(json['entry']),
    };
}

export function DelegationSummaryResponseToJSON(value?: DelegationSummaryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': DelegationSummaryToJSON(value.entry),
    };
}


